import {useState} from "react";

export const ViewMode = {
    INTRO: 0,
    CHOOSE_CONTEST: 1,
    MAKE_PICKS: 2,
    CHOOSE_ENTRY_FEE: 3,
    DONE: 4,
};

export const steps = [
    ViewMode.INTRO,
    ViewMode.CHOOSE_CONTEST,
    ViewMode.MAKE_PICKS,
    ViewMode.CHOOSE_ENTRY_FEE,
    ViewMode.DONE
]

const useOnBoardingPopUpViewModel = ({onClose})=>{
    const [currStep, setCurrStep] = useState(steps[0]);

    const handleNextStepClick = () => {
        if (currStep < ViewMode.DONE) {
            setCurrStep(currStep + 1);
        }
    };
    const handleBackStepClick = () => {
        if (currStep > ViewMode.INTRO) {
            setCurrStep(currStep - 1);
        }
    };
    const handleStepClick = (step) => {
        if (step >= ViewMode.INTRO && step <= ViewMode.DONE) {
            setCurrStep(step);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return {
        steps,
        currStep, setCurrStep,

        handleNextStepClick,
        handleBackStepClick,
        handleStepClick,
        handleClose
    }
}
export default useOnBoardingPopUpViewModel;